export default "__VITE_ASSET__B8jGhAg8__"